var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import ChequeBlockTimer from '../ChequeBlockTimer';
import { isChequeBlocked } from '../../../shared/chequeBlockStorage';
var internalErrorMsg = {
    id: 'member-area.recharge_form_internal_error',
    defaultMessage: 'Внутренняя ошибка системы. Попробуйте позже'
};
var serviceUnavailableMsg = {
    id: 'member-area.recharge_form_service_unavailable',
    defaultMessage: 'Служба пополнения временно недоступна'
};
var errors = defineMessages({
    '-1': {
        id: 'member-area.recharge.incorrect_pin',
        defaultMessage: 'Неверный пин'
    },
    '-11': {
        id: 'member-area.recharge.used_pin',
        defaultMessage: 'Пин уже был использован'
    },
    '-12': {
        id: 'member-area.recharge.expired_pin',
        defaultMessage: 'Пин истек'
    },
    '-100': internalErrorMsg,
    '-1000': internalErrorMsg,
    '-10000': internalErrorMsg,
    '403': serviceUnavailableMsg,
    '404': serviceUnavailableMsg,
    '500': serviceUnavailableMsg
});
var message = defineMessages({
    recharge_continue: {
        id: 'recharge.continue',
        defaultMessage: 'Continue'
    },
    recharge_try_again: {
        id: 'recharge.try_again',
        defaultMessage: 'Try again'
    },
    recharge_check_input_value: {
        id: 'recharge.check_input_value',
        defaultMessage: 'Check input value'
    },
    recharge_check_input_value_attempts: {
        id: 'recharge.check_input_value_attempts',
        defaultMessage: 'attempts left'
    }
});
var BironexForm = /** @class */ (function (_super) {
    __extends(BironexForm, _super);
    function BironexForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.required = function (value) { return value ? '' : _this.props.intl.formatMessage({ id: 'withdraw.required' }); };
        _this.minLength = function (value) {
            var tmpValue = value.replace(/\s/g, "");
            return tmpValue.length === 12 ? '' : _this.props.intl.formatMessage({ id: 'member-area.pin_length' });
        };
        _this.handleBlockExpire = function () {
            _this.props.onBlockExpire();
        };
        _this.isInputBlocked = function () {
            var _a = _this.props, gamblerId = _a.gamblerId, timeout = _a.timeout;
            return (timeout > 0) || isChequeBlocked(gamblerId);
        };
        _this.renderField = function (_a) {
            var input = _a.input, _b = _a.placeholder, placeholder = _b === void 0 ? {} : _b, type = _a.type, _c = _a.meta, touched = _c.touched, error = _c.error, warning = _c.warning, errorCode = _a.errorCode, timeout = _a.timeout, attempts = _a.attempts, maxAttempts = _a.maxAttempts;
            var inputCls = (touched && error) || errorCode ? 'recharge-error' : '';
            var isBlocked = _this.isInputBlocked();
            var disabled = isBlocked || input.value.length !== 12;
            input.value = input.value.replace(/\s/g, "");
            return (_jsxs("div", __assign({ className: 'input' }, { children: [_jsx("input", __assign({}, input, { placeholder: placeholder, type: type, className: inputCls, autoComplete: 'new-password', maxLength: 12, disabled: isBlocked })), !errorCode && touched && ((error && _jsx("div", __assign({ className: "error-message" }, { children: error }))) || (warning &&
                        _jsx("div", { children: warning }))), errorCode && _jsx("div", __assign({ className: "error-message" }, { children: _jsx(FormattedMessage, __assign({}, (errors[errorCode] || internalErrorMsg))) })), _jsx("div", __assign({ className: 'controls', style: { marginTop: 16 } }, { children: _this.props.fetching ? (_jsx("button", { disabled: true, className: "loading" })) : (_jsx("button", __assign({ type: 'submit', disabled: disabled }, { children: _jsx(FormattedMessage, __assign({}, message.recharge_continue)) }))) })), !isBlocked && attempts && maxAttempts && (_jsxs("div", __assign({ style: { color: 'red' } }, { children: [_jsx(FormattedMessage, __assign({}, message.recharge_check_input_value)), " ", attempts, "/", maxAttempts, " ", _jsx(FormattedMessage, __assign({}, message.recharge_check_input_value_attempts))] }))), isBlocked && (_jsx(ChequeBlockTimer, { gamblerId: _this.props.gamblerId, onExpire: _this.handleBlockExpire, renderTime: function (formattedTime) { return (_jsxs("div", __assign({ style: { color: "#000" } }, { children: [_jsx(FormattedMessage, __assign({}, message.recharge_try_again)), " (", formattedTime, ")"] }))); } }))] })));
        };
        return _this;
    }
    BironexForm.prototype.render = function () {
        var _a = this.props, submitAction = _a.submitAction, handleSubmit = _a.handleSubmit, intl = _a.intl, errorCode = _a.errorCode, timeout = _a.timeout, attempts = _a.attempts, maxAttempts = _a.maxAttempts;
        return (_jsx("form", __assign({ onSubmit: handleSubmit(submitAction), id: 'recharge-bironex' }, { children: _jsx(Field, { type: 'tel', component: this.renderField, name: 'pin', errorCode: errorCode, timeout: timeout, attempts: attempts, maxAttempts: maxAttempts, placeholder: intl.formatMessage({ id: 'recharge.pin' }), validate: [this.required, this.minLength] }) })));
    };
    return BironexForm;
}(React.Component));
BironexForm.propTypes = {
    submitAction: PropTypes.func.isRequired,
    handleSubmit: PropTypes.any.isRequired,
    intl: PropTypes.object.isRequired,
    fetching: PropTypes.bool.isRequired,
    gamblerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onBlockExpire: PropTypes.func.isRequired,
};
BironexForm = reduxForm({
    form: 'recharge-bironex'
})(BironexForm);
export default injectIntl(BironexForm);



// WEBPACK FOOTER //
// ./src/components/recharge/forms/BironexForm.jsx